/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';
import { trackPromise } from 'react-promise-tracker';

import {
  failurePostIssuance,
  REQUEST_POST_ISSUANCE,
  successPostIssuance,
} from '../actions/application';
import api from '../../../../../utils/Api';
import { getQuoteData } from '../../../../Quotation/reducers/quote';
import { areas } from '../../../../../utils/Constants';
import mapIssuanceForApi, { sanitizeQuotationRequest } from '../../../../../utils/mapIssuanceForApi';

export function* watchRequestSaveIssuance() {
  yield takeLatest(REQUEST_POST_ISSUANCE, requestPostIssuanceSaga);
}

function* requestPostIssuanceSaga({ payload: issuance }) {
  try {
    const quote = yield select(getQuoteData);
    const withDifferentHolder = quote?.requestData?.withDifferentHolder ?? false;
    const sanitizedIssuance = mapIssuanceForApi(issuance, { withDifferentHolder });
    const quotation = {};
    quotation.request = sanitizeQuotationRequest(quote.requestData, { withDifferentHolder });
    let typeId = 0;
    if (quote?.deductibleSelected?.paymentType) {
      const payment = quote.deductibleSelected.deductible.paymentType.find(
        (p) => p.typeDescription === quote.deductibleSelected.paymentType);
      typeId = payment.typeId;
    } else {
      typeId = quote.deductibleSelected.typeId;
    }
    sanitizedIssuance.quotationJson = JSON.stringify(quotation);
    sanitizedIssuance.state = 'SOLICITUD';
    sanitizedIssuance.lastStep = '#DOC';
    sanitizedIssuance.QuotationProductId = quote.requestData.productId;
    sanitizedIssuance.DeductibleSelectedId = quote.deductibleSelected.deductibleId;
    sanitizedIssuance.QuotationSelectedTotalValue = quote.deductibleSelected.total;
    sanitizedIssuance.SelectedBranchOfficeId = quote.requestData.branchOfficeId;
    sanitizedIssuance.SaleProcessId = quote.requestData.SaleProcessId;
    sanitizedIssuance.PaymentMethod = typeId;
    const response = yield call(fetchPostIssuance, sanitizedIssuance);
    // TODO: set data of the application form to application slice
    yield put(successPostIssuance(response.data, sanitizedIssuance.billingData,
      sanitizedIssuance.insuranceHolder));
  } catch (e) {
    yield put(failurePostIssuance(e?.message));
  }
}

const fetchPostIssuance = (issuance) => trackPromise(api
  .post(process.env.REACT_APP_ISSUANCE_URL, issuance), areas.global);
